(function () {
    'use strict';

    angular.module('ShargoApp').controller('404Controller', function ($scope, $rootScope, $location, Configuration) {
		$rootScope.pageConfiguration = {
			footer: true,
			header: {
				solid: -1000,
				background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
				preheader: false,
				headerLink: $rootScope.url('home'),
				headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
				logIn: true,
				dashboard: true,
				callToAction: {
					link: $rootScope.device.isDesktop ? $rootScope.url('sendpackage') : $rootScope.url('contact'),
					text: $rootScope.device.isDesktop ? 'header.ask4Shargo' : 'header.contact',
					target: '',
					hide: false,
					disabled: false
				},
				profile: true
			}
		};

        $scope.redirect = function (url) {
            $location.path(url);
            $rootScope.$emit('redirection', {});
        };
    })
})();